exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.tab-item {\n    height: 50px;\n}\n\n/* .featured-category-products>.slick-dots {\n    padding-top: 2rem !important;\n} */\n.additional_products {\n    width: 600px;\n}\n@media screen and (max-width: 1300px) {\n.additional_products {\n        width: 400px;\n}\n}\n@media screen and (max-width: 1051px) {\n.additional_products {\n        width: 200px;\n}\n}\n@media screen and (max-width: 991px) {\n.additional_products {\n        width: 100%;\n}\n}\n", ""]);

// exports
